import React from 'react';
import { CubeGrid } from 'better-react-spinkit'
import { ModalContainer, ModalDialog } from 'react-modal-dialog';

const style = {
  display: 'flex',
  justifyContent: 'center',
  align: 'center',
};

const Loading = ({title}) =>
<div className="Loading">
    <ModalContainer>
      <ModalDialog>
        <div className="Loading" >
          <div>{title ? <h3>{title}</h3>:<h3>Laddar...</h3>}</div>
          <div style={style}><CubeGrid size={50}/></div>
        </div>
      </ModalDialog>
    </ModalContainer>
</div>

export default Loading